import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Icon } from "@pdfking/workflow/components/Icon"
import { RootMixin } from "@pdfking/workflow/mixins/RootMixin"
import make_translations from "@pdfking/workflow/utils/make_translations"
import navigate from "../routes/navigate"
import { MARKDOWN_VIEW } from "../routes/urls"

export const Markdown = CreateRenderFunction({
  computed: {
    translations: () => make_translations("actions"),
  },
  props: {
    content: "",
    id: "",
    name: "",
    cols: null as number | null,
    rows: null as number | null,
    placeholder: "",
  },
  data: {
    content_mutable: "" as string,
  },
  init() {
    this.content_mutable = this.content
  },
  methods: {
    open_editor() {
      navigate(MARKDOWN_VIEW, {
        selector: `#${(this.root as HTMLElement)?.id} textarea`,
      })
    },
  },
  mixins: [RootMixin],
  render() {
    return (
      <div id={this.id} class="onhover" style="position: relative">
        <textarea
          value={this.content_mutable}
          onInput={(e: Event) => {
            this.content_mutable = (e.target as HTMLTextAreaElement).value
          }}
          class="form-control"
          name={this.name}
          placeholder={this.placeholder}
          style="min-height: 200px"
        />
        <div
          class="onhover-show-visibility border border-top-0 border-end-0 bg-white ps-2 pe-2"
          style="position: absolute; top: 1px; right: 1px; cursor: pointer"
        >
          <a
            class="small text-muted clickable"
            onClick={(e: Event) => {
              e.preventDefault()
              this.open_editor()
            }}
          >
            {this.translations.actions.CHANGE} <Icon name="ARROW_RIGHT" />
          </a>
        </div>
      </div>
    )
  },
})
